import store from '../../index';

export const getRoleById = (id) => store.getState().roles.items.find((role) => role._id === id);
